import { render, staticRenderFns } from "./NovoEditPerfis.vue?vue&type=template&id=2c8960fc"
import script from "./NovoEditPerfis.vue?vue&type=script&lang=js"
export * from "./NovoEditPerfis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports